import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../apiAccess/PromiseStateContainer';
import BASE_URL from '../apiAccess/urls';
import { createSubheaderRow, createNutrientRows } from '../util/util';
import ComponentsTable from './ComponentsTable';

class Basic extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    this.props.setCsvHeader([
      {label: 'Category', key: 'category'},
      {label: 'Nutrient', key: 'nutrient'},
      {label: 'Unit', key: 'unit'},
      {label: 'Quantity per Serve', key: 'qps'},
      {label: '%DI per Serve', key: 'rdi'},
      {label: 'Quantity per 100 g', key: 'qpg'},
    ]);
  }

  render() {
    const {
      unitFetch,
      proximatesComponentSetFetch,
      fatsComponentSetFetch,
      carbohydratesComponentSetFetch,
      vitaminsComponentSetFetch,
      mineralsComponentSetFetch,
      fullFetch,
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch,
          proximatesComponentSetFetch,
          fatsComponentSetFetch,
          carbohydratesComponentSetFetch,
          vitaminsComponentSetFetch,
          mineralsComponentSetFetch,
          fullFetch,
        ])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([
    units,
    proximatesComponentSet,
    fatsComponentSet,
    carbohydratesComponentSet,
    vitaminsComponentSet,
    mineralsComponentSet,
    full,
  ]) {
    const tableData = createSubheaderRow('Proximates')
      .concat(createNutrientRows(proximatesComponentSet.components, full, units))
      .concat(createSubheaderRow('Fats'))
      .concat(createNutrientRows(fatsComponentSet.components, full, units))
      .concat(createSubheaderRow('Carbohydrates'))
      .concat(createNutrientRows(carbohydratesComponentSet.components, full, units))
      .concat(createSubheaderRow('Vitamins'))
      .concat(createNutrientRows(vitaminsComponentSet.components, full, units))
      .concat(createSubheaderRow('Minerals'))
      .concat(createNutrientRows(mineralsComponentSet.components, full, units));

    return (
      <ComponentsTable
        tableType='basic'
        tableData={tableData}
        setCsvData={this.props.setCsvData}
      />
    );
  }
}

Basic.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  proximatesComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fatsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbohydratesComponentSetFetch: PropTypes.instanceOf(PromiseState),
  vitaminsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  mineralsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fullFetch: PropTypes.instanceOf(PromiseState),
  recordid: PropTypes.string.isRequired,
  servingSize: PropTypes.number,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

export default connect(props => {
  let query = typeof props.servingSize === 'number' ? `?amount=${props.servingSize}&` : '?';
  return {
    unitFetch: `${BASE_URL}/unit`,
    proximatesComponentSetFetch: `${BASE_URL}/component/set/6`,
    fatsComponentSetFetch: `${BASE_URL}/component/set/7`,
    carbohydratesComponentSetFetch: `${BASE_URL}/component/set/8`,
    vitaminsComponentSetFetch: `${BASE_URL}/component/set/9`,
    mineralsComponentSetFetch: `${BASE_URL}/component/set/10`,
    fullFetch: `${BASE_URL}/fiav/food/${props.recordid}${query}comp_group_id=12`,
  };
})(Basic);



// WEBPACK FOOTER //
// ./src/components/foodDetail/Basic.js